import { useCallback, useEffect, useState } from "react";

export function useCategories({ autoFetch = true } = {}) {
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState();

  const createCategory = async ({ values }) => {
    const payload = {
      id: values.id,
      name: values.name,
      type: values.type,
      description: values.description,
      image: values.image,
    };
    const response = await fetch(`/category`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      return response.json();
    } else {
      console.error("Error adding category", { error: response.body });
      return false;
    }
  };

  const fetchCategories = useCallback(async () => {
    if (!autoFetch) return;
    setIsLoading(true);
    await fetch("/category", { headers: { accept: "*/*" } })
      .then((res) => res.json())
      .then((data) => {
        setCategories(data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching admin categories:", err);
        setIsLoading(false);
      });
  }, [autoFetch]);

  const categoryById = async ({ categoryId }) => {
    setIsLoading(true);
    const response = await fetch(`/category/${categoryId}`, {
      headers: { accept: "*/*" },
    });

    setIsLoading(false);

    if (response.ok) {
      return response.json();
    } else {
      console.error("Error fetching admin categories", {
        error: response.body,
      });
      return false;
    }
  };

  const editCategory = async ({ values }) => {
    console.log({ values });
    const payload = {
      id: values.id,
      name: values.name,
      type: values.type,
      description: values.description,
      image: values.image,
    };
    const response = await fetch(`/category`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (response.ok) {
      return true;
    } else {
      console.error("Error updating category", { error: response.body });
      return false;
    }
  };

  const deleteCategory = async ({ category }) => {
    if (window.confirm("¿Está seguro de eliminar esta categoría?")) {
      const response = await fetch(`/category`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(category),
      });
      if (response.ok) {
        return true;
      } else {
        console.error("Error deleting category", { error: response.body });
        return false;
      }
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return {
    categories,
    categoryById,
    createCategory,
    isLoading,
    deleteCategory,
    editCategory,
    refetch: fetchCategories,
  };
}
